import { VueOfflineStorage } from "vue-offline";

/* Cache service to retrieve/update objects within the $offlineStorage. */
class modelCacheService {
  set(module, key, payload) {
    let model = VueOfflineStorage.get(module);
    if (!model) {
      model = {};
    }
    model[key] = payload;
    VueOfflineStorage.set(module, model);
  }

  get(module, key) {
    let model = VueOfflineStorage.get(module);
    if (!model) {
      return model;
    }
    return model[key];
  }
}

export default new modelCacheService();
